// extracted by css-extract-rspack-plugin
export default {"dialog":"Zo0J9ov7IL05pbwd","list":"ED12TKDa0SPjfopX","item":"MQdZxtm23YwZf6D9"};